export const ROUNDING_FACTOR = {
  ROUND: "round",
  TENTH: "tenth",
  HUNDRETH: "hundreth",
  NONE: "none",
};
